import * as aor from "react-admin";
import React from "react";
import CardActions from "@material-ui/core/CardActions";
import DeleteButton from "../../components/DeleteButton";
import EnableButton from "../../components/EnableButton";
import AutoCompleteInputOld from "../../components/AutoCompleteInputOld";

import MainCompanySelect from "../../components/MainCompanySelect";
import { Field } from "redux-form";
import { POLICY_COMPANIES } from "../../common/rolesManagement";
import { getUserCompany } from "../../common/authClient";
const typeOptions = {
    resource: "installation_types",
    display: "name",
    label: "Può gestire installazioni:",
    isMulti: true,
    notRequired: false
};

const Actions = ({ permissions, basePath, data }) => {
    if (data) {
        const record = { data };
        const del = record && record.data && record.data.deleted;
        return (
            <CardActions
                style={{ zIndex: 2, display: "inline-block", float: "right" }}
            >
                <aor.ShowButton basePath={basePath} record={data} />
                {//DeleteButton (used for disable) is visible only if company is not disabled
                data.id !== parseInt(getUserCompany, 10) &&
                    permissions &&
                    !del &&
                    (permissions.includes(POLICY_COMPANIES.DISABLE) ||
                        (data.master_company_id &&
                            permissions.includes(
                                POLICY_COMPANIES.DISABLE_SLAVE_ONLY
                            ))) && (
                        <DeleteButton
                            undoable={true}
                            basePath={basePath}
                            record={data}
                            text="resources.companies.actions.disable"
                            resource="companies"
                            message={"Azienda disabilitata"}
                            redirect={"companies"}
                        />
                    )}

                {//EnableButton is visible only if company is disabled
                permissions &&
                    (permissions.includes(POLICY_COMPANIES.DISABLE) ||
                        (data.master_company_id &&
                            permissions.includes(
                                POLICY_COMPANIES.DISABLE_SLAVE_ONLY
                            ))) &&
                    del && (
                        <EnableButton
                            action="enable_company"
                            resource_id={data.id}
                            current_entity="companies"
                            redirect="/companies"
                        />
                    )}

                {//DeleteButton (used for delete) is visible only if company is disabled
                permissions &&
                    (permissions.includes(POLICY_COMPANIES.DELETE) ||
                        (data.master_company_id &&
                            permissions.includes(
                                POLICY_COMPANIES.DISABLE_SLAVE_ONLY
                            ))) &&
                    del && (
                        <DeleteButton
                            undoable={true}
                            basePath={basePath}
                            record={data}
                            text="resources.companies.actions.delete"
                            resource="companies"
                            message={"Azienda eliminata"}
                            redirect={"companies"}
                            dialogContentTitle={"Cancella"}
                            dialogContentText={
                                "ra.actions.deleteSelectedResource"
                            }
                        />
                    )}
                <aor.ListButton basePath={basePath} />
            </CardActions>
        );
    } else {
        return null;
    }
};

const MyToolbar = props => (
    <aor.Toolbar {...props}>
        <aor.SaveButton redirect="show" submitOnEnter={true} />
    </aor.Toolbar>
);

export default ({ permissions, ...props }) => (
    <aor.Edit
        {...props}
        undoable={false}
        title={"resources.companies.nameSingular"}
        actions={<Actions permissions={permissions} />}
    >
        <aor.SimpleForm toolbar={<MyToolbar />} redirect="show">
            <aor.TextField source="vatin" />
            <aor.TextInput source="name" validate={[aor.required()]} />
            <aor.TextInput source="seller_code" validate={[aor.required()]} />

            <Field
                {...props}
                name="master_company_id"
                component={MainCompanySelect}
            />

            {permissions &&
                permissions.includes(POLICY_COMPANIES.UPDATE_LICENSES) && (
                    <aor.FormDataConsumer>
                        {({
                            formData, // The whole form data
                            ...rest
                        }) => {
                            return (
                                <Field
                                    name="license_ids"
                                    component={AutoCompleteInputOld}
                                    {...{
                                        options: typeOptions
                                    }}
                                    validate={[aor.required()]}
                                />
                            );
                        }}
                    </aor.FormDataConsumer>
                )}
        </aor.SimpleForm>
    </aor.Edit>
);



// WEBPACK FOOTER //
// ./src/resources/Companies/Edit.js